export const ORGANIZATION_FLAGS = {
  IS_SHOWED_IN_AFFILIATION: 'IS_SHOWED_IN_AFFILIATION'
}

export const ANTENNAS_FLAGS = ORGANIZATION_FLAGS
